/** Paleta alineada con chili-app/tailwind.config.js */
export const CHILI_BRAND_COLORS = {
  chilliRed: "#FA0A0A",
  chilliGreen: "#50B7C0",
  chilliYellow: "#F7B917",
  chilliBlue: "#1E90FF",
  chilliPurple: "#800080",
  chilliOrange: "#FFA500",
  chilliPink: "#FF69B4",
  chilliBrown: "#A52A2A",
  chilliCyan: "#00FFFF",
  chilliMagenta: "#FF00FF",
  chilliLime: "#00FF00",
  chilliTeal: "#008080",
  chilliIndigo: "#4B0082",
  chilliButtons: "#DC2C27",
  greenButtons: "#50834C",
  varoBlue: "#15225D",
} as const;

/** Colores para avatares con iniciales (fondo + texto legible) */
export const CHILI_AVATAR_PALETTE: { bg: string; text: string }[] = [
  { bg: CHILI_BRAND_COLORS.chilliRed, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliGreen, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliYellow, text: CHILI_BRAND_COLORS.varoBlue },
  { bg: CHILI_BRAND_COLORS.chilliBlue, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliPurple, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliOrange, text: CHILI_BRAND_COLORS.varoBlue },
  { bg: CHILI_BRAND_COLORS.chilliPink, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliTeal, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliIndigo, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.greenButtons, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliButtons, text: "#ffffff" },
  { bg: CHILI_BRAND_COLORS.chilliBrown, text: "#ffffff" },
];
